import axios from "axios";
import Image from "next/image";
import { useEffect, useState } from "react";
import Meta from "../../components/Meta";
import Collections from "../../components/collections-wide/collection-content";
import FilterSortHeader from "../../components/collections-wide/collection-content/FilterSortHeader";
import Sidebar from "../../components/collections-wide/sidebar";

// APIS
// https://api.impactoverse.com/api/app/categories?kind=CAMPAIGN
// https://api.impactoverse.com/api/app/categories?kind=NFT
// https://api.impactoverse.com/api/app/list-assets?limit=75&offset=0&isSold=false&priceMin=0&priceMax=100000000000000000&percentageMin=0&percentageMax=100&impactCategory=&nftCategory=&username=&itemName=

const Index = () => {
  const [assetsList, setAssetsList] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState([]);
  const [currentPage, setCurrentPage] = useState(2);
  const [loading, setLoading] = useState(false);
  const [impactCategory, setImpactCategory] = useState([]);
  const [nftCategory, setNftCategory] = useState([]);

  const [filters, setFilters] = useState({
    limit: 75,
    offset: 0,
    isSold: false,
    priceMin: 0,
    priceMax: 100000000000000,
    percentageMin: 0,
    percentageMax: 100,
    impactCategory: "",
    nftCategory: "",
    username: "",
    itemName: "",
  });

  useEffect(() => {
    getAssets(filters);
    getImpactCategory();
    getNftCategory();
  }, []);

  const getAssets = async (filterList) => {
    try {
      const result = await axios.get(
        `https://api.impactoverse.com/api/app/list-assets?`,
        { params: filterList }
      );

      const { success, assetList, assetCount } = result.data;

      if (success) {
        setAssetsList(assetList);
        setTotalItems(assetCount);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleChangeInput = async (e) => {
    try {
      let temp = { ...filters };
      temp[e.target.name] = e.target.value;
      setFilters(temp);
    } catch (e) {
      console.log(e);
    }
  };

  const handleCheckBox = (e) => {
    try {
      let temp = { ...filters };
      if (e.target.checked) {
        temp[e.target.name] = e.target.value;
      } else {
        temp[e.target.name] = "";
      }
      setFilters(temp);
    } catch (e) {
      console.log(e);
    }
  };

  const onSubmit = (event) => {
    try {
      event.preventDefault();
      getAssets(filters);
    } catch (e) {
      console.log(e);
    }
  };

  const onPagination = async (pageNumber) => {
    try {
      if (!loading) setLoading(true);

      const limit = pageNumber * filters.limit;

      let temp = {
        ...filters,
        limit: limit,
      };

      const result = await axios.get(
        `https://api.impactoverse.com/api/app/list-assets?
        `,
        { params: temp }
      );

      const { success, assetList, assetCount } = result.data;

      if (success) {
        setAssetsList(assetList);
        setCurrentPage((prev) => prev + 1);
      }
      setLoading(false);
    } catch (e) {
      console.log(e);
    }
  };

  const clearAll = async () => {
    try {
      let data = {
        limit: 75,
        offset: 0,
        isSold: false,
        priceMin: 0,
        priceMax: 100000000000000,
        percentageMin: 0,
        percentageMax: 100,
        impactCategory: "",
        nftCategory: "",
        username: "",
        itemName: "",
      };
      setFilters(data);

      getAssets(data);
    } catch (e) {
      console.log(e);
    }
  };

  const getImpactCategory = async () => {
    try {
      const result = await axios.get(
        `https://api.impactoverse.com/api/app/categories?kind=NFT`
      );

      const { categoriesList } = result.data;

      setNftCategory(categoriesList);
    } catch (e) {
      console.log(e.message);
    }
  };

  const getNftCategory = async () => {
    try {
      const result = await axios.get(
        `https://api.impactoverse.com/api/app/categories?kind=CAMPAIGN`
      );

      const { categoriesList } = result.data;

      setImpactCategory(categoriesList);
    } catch (e) {
      console.log(e.message);
    }
  };

  return (
    <>
      <Meta title="Impact DOT MarketPlace" />
      {/* End page title */}

      <main className="mt-24">
        <div className="mx-auto mb-5 text-center">
          <h2 className="font-display text-3xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase">
            Explore Impact DOTs
          </h2>
        </div>
        {/* Collections */}
        <section className="relative pt-16 pb-24">
          <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden !ml-0">
            <Image
              width={1519}
              height={773}
              priority
              src="/images/gradient_light.jpg"
              alt="gradient"
              className="h-full w-full object-cover"
            />
          </picture>
          <div className="px-6 xl:px-24">
            {/* Filters / Sorting */}
            <FilterSortHeader clearAll={clearAll} />
            {/* end filters / sorting */}
            <div className="lg:flex mt-6">
              {/* Sidebar */}
              <Sidebar
                handleChangeInput={handleChangeInput}
                handleCheckBox={handleCheckBox}
                filters={filters}
                onSubmit={onSubmit}
                impactCategory={impactCategory}
                nftCategory={nftCategory}
              />
              {/* end sidebar */}
              {/* Content */}
              <div className="lg:w-4/5 js-collections-content">
                <div className="mb-8 pb-px">
                  <h1 className="pt-3 mb-2 font-display text-2xl font-medium text-jacarta-700 dark:text-white">
                    Explore Impact DOTs
                  </h1>
                  <p className="dark:text-jacarta-400 font-medium text-2xs">
                    {totalItems} items
                  </p>
                </div>

                <Collections assetsList={assetsList} />

                {loading && <>Loading...</>}
                <br />
                <br />

                {assetsList.length < totalItems && (
                  <div className="mt-10 text-center">
                    <button
                      onClick={() => onPagination(currentPage)}
                      className="bg-accent shadow-accent-volume hover:bg-accent-dark inline-block rounded-full py-3 px-8 text-center font-semibold text-white transition-all uppercase"
                    >
                      Load More
                    </button>
                  </div>
                )}

                <nav aria-label="Page navigation example">
                  <ul className="flex items-center -space-x-px h-8 text-sm">
                    {/* <li>
                      <a
                        href="#"
                        class="flex items-center justify-center px-3 h-8 ms-0 leading-tight text-gray-500 bg-white border border-e-0 border-gray-300 rounded-s-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                      >
                        <span class="sr-only">Previous</span>
                        <svg
                          class="w-2.5 h-2.5 rtl:rotate-180"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 6 10"
                        >
                          <path
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M5 1 1 5l4 4"
                          />
                        </svg>
                      </a>
                    </li> */}

                    {/* <li>
                      <a
                        href="#"
                        class="flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 rounded-e-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                      >
                        <span class="sr-only">Next</span>
                        <svg
                          class="w-2.5 h-2.5 rtl:rotate-180"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 6 10"
                        >
                          <path
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="m1 9 4-4-4-4"
                          />
                        </svg>
                      </a>
                    </li> */}
                  </ul>
                </nav>
              </div>
              {/* end content */}
            </div>
          </div>
        </section>
        {/* end collections */}
      </main>
    </>
  );
};

export default Index;
